import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { actionTypes } from '../actions/types';
import { errorNames, getErrorMessage, serviceError } from '../util/mappings/errorName';

type AppActions = import('../actions/types').AppActions;

export interface ErrorReducer {
    exception: RequestExceptionWithResponse | undefined;
    errorMessage: string;
}

export const initialState: ErrorReducer = {
    exception: undefined,
    errorMessage: '',
};

export const errorReducer = (state = initialState, action: AppActions = {} as AppActions): ErrorReducer => {
    switch (action.type) {
        case actionTypes.FEATURE_TOGGLE_FAILED:
        case actionTypes.FETCH_USER_SESSION_FAILED:
        case actionTypes.UPDATE_CALCULATOR_CACHE_FAILED:
        case actionTypes.FETCH_CALCULATOR_CACHE_FAILED:
        case actionTypes.FETCH_CONSENT_FAILED: {
            return {
                ...state,
                exception: action.payload,
                errorMessage: action.payload.message,
            };
        }

        case actionTypes.KYC_ERROR: {
            return {
                ...state,
                errorMessage: serviceError,
            };
        }

        case actionTypes.CREATE_SBL_CONSENT_FAILED: {
            const { errorName } = action.payload;
            return {
                ...state,
                errorMessage: getErrorMessage(errorName),
            };
        }

        case actionTypes.SEND_FEEDBACK_FAILED:
        case actionTypes.FETCH_PRODUCTS_FAILED:
        case actionTypes.FETCH_PRODUCT_INFO_FAILED:
        case actionTypes.FETCH_ONGOING_APPLICATIONS_FAILED: {
            return {
                ...state,
                exception: action.payload,
                errorMessage: serviceError,
            };
        }

        case actionTypes.FETCH_VEHICLE_INFO_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);
            if (errorMessage === errorNames.eurotaxPlateNotFound) return state;
            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }

        case actionTypes.UPGRADE_ONGOING_APPLICATION_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);

            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }

        case actionTypes.FETCH_USER_CONTEXT_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);

            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }
        case actionTypes.FETCH_CUSTOMER_KYC_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);

            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }
        case actionTypes.SEND_APPLICATION_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);

            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }
        case actionTypes.FETCH_APPLICATION_FAILED:
        case actionTypes.UPDATE_APPLICATION_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);
            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }

        default:
            return state;
    }
};
